/**
 * Mouse
 */
const mouse = {}
mouse.x = 0
mouse.y = 0
mouse.easings = {}

const easings = [0.01]

for(const _easing of easings)
{
    const easing = {}
    easing.strength = _easing
    easing.x = 0
    easing.y = 0

    mouse.easings[`${easing.strength}`] = easing
}

document.addEventListener('mousemove', (event) =>
{
    mouse.x = event.clientX
    mouse.y = event.clientY
})

/**
 * Tick
 */
let time = Date.now()

const tick = () =>
{
    window.requestAnimationFrame(tick)

    const newTime = Date.now()
    let delta = newTime - time
    time = newTime

    if(delta > 60)
    {
        delta = 60
    }

    // Update mouse
    const easingKeys = Object.keys(mouse.easings)
    for(const _easingKey of easingKeys)
    {
        const easing = mouse.easings[_easingKey]
        easing.x += (mouse.x - easing.x) * easing.strength * delta
        easing.y += (mouse.y - easing.y) * easing.strength * delta
    }
}

window.requestAnimationFrame(tick)

/**
 * Mixin
 */
export default {
    created: function()
    {
        this.mouse = mouse
    }
}



// WEBPACK FOOTER //
// ./src/mixins/Mouse.js